import { useEffect, useRef } from "react";
import { Reveal, Overline } from "./Reveal";

export default function Aftermovie() {
    const iframeRef = useRef(null);

    useEffect(() => {
        const onBlur = () => {
            if (document.activeElement === iframeRef.current) {
                window.dispatchEvent(new Event("gala:stop-music"));
            }
        };
        window.addEventListener("blur", onBlur);
        return () => window.removeEventListener("blur", onBlur);
    }, []);

    return (
        <section id="aftermovie" data-testid="aftermovie-section" className="relative bg-night-deep px-6 sm:px-12 lg:px-20 py-28 sm:py-36">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                <Reveal>
                    <Overline>L'Aftermovie</Overline>
                    <h2 className="mt-4 font-display text-4xl sm:text-5xl md:text-6xl tracking-tight">
                        Le film de<br />la <em className="text-gold">nuit.</em>
                    </h2>
                </Reveal>
                <Reveal delay={0.1}>
                    <p className="max-w-xs text-sm font-light leading-relaxed text-white/50 md:text-right">
                        Le meilleur de la soirée, monté en images. Installez-vous — la bande-son s'efface toute seule.
                    </p>
                </Reveal>
            </div>

            <Reveal delay={0.15}>
                <div className="relative max-w-5xl mx-auto">
                    <div className="absolute -inset-3 border border-gold/25 translate-x-3 translate-y-3 pointer-events-none" />
                    <div data-testid="aftermovie-frame" className="relative border border-gold/20 [clip-path:polygon(2%_0,100%_3%,98%_100%,0_97%)]">
                        <div className="aftermovie-embed">
                            <iframe
                                ref={iframeRef}
                                src="https://space-trial.video-dns.com/DCxHyvVeNg/player.html"
                                width="640" height="360" frameBorder="0" scrolling="no" allowFullScreen
                            />
                        </div>
                    </div>
                    <div className="mt-6 flex items-center justify-between text-[10px] tracking-[0.3em] uppercase text-white/40">
                        <span>L'aftermovie · MMXXVI</span>
                        <span>Le Piesmont · Lasne</span>
                    </div>
                </div>
            </Reveal>
        </section>
    );
}
